import React, {useState, useEffect} from 'react';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";

import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom';
import useMediaQuery from '@material-ui/core/useMediaQuery';

//import DownloadIcon from "../../../images/icons/download-icon.svg";

import BotaoDownload from "../botaoDownload";

import UseStyles from "./styles";

import { useSnackbar } from 'notistack';

import { getDocumentos } from '../../../services/reuniao/ReuniaoService';

import { download } from '../../../services/documento/DocumentoService';

const DocListar = (props) => {

  const {dados} = props;

  const { enqueueSnackbar } = useSnackbar();

  const classes = UseStyles();

  const downloadIcon = (color, width = 20, height = 20) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`0 0 ${width} ${height}`}  >
      <path fill={color} fill-rule="nonzero" d="M9 0v2h2V0H9zm0 4v8.586L5.707 9.293l-1.414 1.414L10 16.414l5.707-5.707-1.414-1.414L11 12.586V4H9zM0 15v3c0 1.093.907 2 2 2h16c1.093 0 2-.907 2-2v-3h-2v3H2v-3H0z" />
    </svg>
  );

  const separarNome = (nome) => nome.split('.')[0];
  const separarTipo = (tipo) => tipo.split('.')[1];
  const getSize = (numero) => {
    if (numero >= (1024 * 1024 * 1024)) {
      return `${parseInt(numero / (1024 * 1024 * 1024))}gb`;
    }
    if (numero >= (1024 * 1024)) {
      return `${parseInt(numero / (1024 * 1024))}mb`;
    }
    if (numero >= 1024) {
      return `${parseInt(numero / 1024)}kb`;
    }
    return `${numero}bytes`;
  }

  const getLastUploadDate = (data) => {
    const dataHoje = new Date().getTime();
    const dataUpload = data || dataHoje;
    const dias = dataHoje - dataUpload;
    return dias >= 1000 * 3600 * 24 ? parseInt((dataHoje - dataUpload) / (1000 * 3600 * 24)) : 0;
  };

  const [hover,setHover] = useState(-99);
  const isXs = useMediaQuery('(min-width:600px)');

  const [arquivos, setArquivos] = useState([]); 

  const handleDownload = async (documentoSelecionado) => {
    const { id, nome, formato } = documentoSelecionado;
    try {
      const response = await download(id);
      const url = URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      document.body.appendChild(a);
      a.download = `${nome}.${formato}`;
      a.click();
    } catch (e) {
      enqueueSnackbar('Ocorreu um erro ao realizar o download', { variant: 'error' })
    }
  }

  useEffect(() => {
    if(dados && dados.id) {
      getDocumentos(dados.id).then((response) => {
        if (response && response.status === 200) {
          const { data } = response;
          setArquivos(data)
        }
      });
    }
  }, [])

  return (
    <>
      {arquivos.length > 0 &&
        <div style={{ marginTop: 12 }}>
          <div style={{ padding: 12 }}>
            <Grid container spacing={2} justifyContent="center">
              <Grid item sm={4} xs={12}>
                <Typography className={classes.item} style={!isXs ? {textAlign:'center'} : {}}>Nome</Typography>
              </Grid>
              <Grid item sm={3} xs={12}>
                <Typography className={classes.item} style={!isXs ? {textAlign:'center'} : {}}>Tipo</Typography>
              </Grid>
              <Grid item sm={3} xs={12}>
                <Typography className={classes.item} style={!isXs ? {textAlign:'center'} : {}}>Tamanho</Typography>
              </Grid>
            </Grid>
          </div>
          <div className={classes.body}>
            <Grid container spacing={0}>
              {arquivos.map((arquivo, key) => (
                <>
                  {key !== 0 && <Grid key={key} style={{ margin: 0, padding: '0 ', marginBlockEnd: 0, marginBlockStart:0 }} item xs={12}><hr style={{ border: '0.5px solid #dfdfe6', marginBlockEnd: 0, marginBlockStart:0 }} /></Grid>}
                  <Grid onMouseEnter={() => setHover(key)} onMouseLeave={() => setHover(-99)} className={classes.content} item xs={12}>
                    <Grid container spacing={0}>
                      <Grid key={arquivo.nome + key + '1'} style={{minHeight:60}} item sm={4} xs={12}>
                        <Typography style={!isXs ? {textAlign:'center', width:'100%'} : {}} className={hover === key ?  classes.nomeArquivoHover : classes.nomeArquivo}>{separarNome(arquivo.nome)}</Typography>
                        <Typography style={!isXs ? {textAlign:'center', width:'100%'} : {}} className={classes.arquivoDetalhe}>{separarTipo(arquivo.nome)}</Typography>
                      </Grid>
                      <Grid key={arquivo.nome + key + '2'} style={{ display: 'flex', alignItems: 'center', minHeight:60 }} item sm={3} xs={12}>
                        <Typography style={!isXs ? {textAlign:'center', width:'100%'} : {}} className={hover === key ? classes.arquivoTamanhoHover : classes.arquivoTamanho}>{arquivo.descricaoTipo}</Typography>
                      </Grid>
                      <Grid key={arquivo.nome + key + '3'} style={{ display: 'flex', alignItems: 'center' , minHeight:60 }} item sm={3} xs={12}>
                        <Typography style={!isXs ? {textAlign:'center', width:'100%'} : {}} className={hover === key ? classes.arquivoTamanhoHover : classes.arquivoTamanho}>{getSize(arquivo.tamanho)}</Typography>
                      </Grid>
                      <Grid key={arquivo.nome + key + '4'} style={{ display: 'flex', justifyContent: 'center', minHeight:48 }} item  sm={2} xs={12}>
                        <BotaoDownload onClickHandle={() => handleDownload(arquivo)} />
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              ))}
            </Grid>
          </div>
        </div>}
    </>
  );
}

export default DocListar;
